// 活動頁 banner 輪播
'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import '../../styles/swipers.scss';
import { EventsSwiperSlide } from './EventSwiperSlide';

const EventsSwiper = ({ banners }) => {
    return (
        <section className="w-full max-h-[300px] overflow-hidden mt-[12px] mx-[auto] max-w-[1840px]">
            <Swiper
                id="events-swiper"
                className="w-full h-full overflow-hidden mx-auto"
                modules={[Autoplay, Navigation]}
                centeredSlides={true} // 居中顯示當前 slide
                slidesPerView={1.1}
                spaceBetween={10}
                loop={true}
                navigation={true}
                direction={'horizontal'} // 水平方向
                freeMode={true}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: true,
                }}
                breakpoints={{
                    // when window width is >= 280,
                    600: {
                        slidesPerView: 1.3,
                    },
                    768: {
                        slidesPerView: 1.5,
                    },
                    900: {
                        slidesPerView: 1.8,
                        spaceBetween: 20,
                    },
                    1190: {
                        slidesPerView: 2.3,
                    },
                    1440: {
                        slidesPerView: 2.8,
                    },
                    1920: {
                        slidesPerView: 3,
                    },
                }}
            >
                {banners.map((banner, i) => {
                    const link = banner?.actSlug ? '/events/' + banner?.actSlug : banner?.link;
                    return (
                        <SwiperSlide key={`banner_${i}`}>
                            <EventsSwiperSlide
                                banner={banner}
                                link={link}
                            />
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </section>
    );
};

export default EventsSwiper;
